import { http } from "frontend/src/api/client";
export var getViewerAudioAdvertisements = function () {
    return http.api
        .get("tracks/my")
        .then(function (_a) {
        var data = _a.data.data;
        return data.map(function (_a) {
            var id = _a.id, title = _a.title, formatted_duration = _a.formatted_duration, duration = _a.duration, url = _a.url;
            return ({
                type: "private",
                id: id,
                title: title,
                duration: { seconds: duration, formatted: formatted_duration },
                url: url,
            });
        });
    });
};
